import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEnvironmentsforUser } from '../../api/documentAPI';
import { useChatEnvironmentAtom } from '../../atoms/chat/useChatEnvironmentAtom';
import  {useTabItemIdAtom } from '../../atoms/chat/useTabItemIdAtom';

import tabConfig from '../../config/tabConfig';
import useCookie from '../../hooks/useCookie';

const Tabs = ({ selectedTab, handleTabClick }) => {

    const { t } = useTranslation();
    const [, setEnvCookie] = useCookie("ENV");
    const [, setTitCookie] = useCookie("TIT");
    const [tabItemId, setTabItemId] = useTabItemIdAtom(); 
    const [chatEnvironmentId, setChatEnvironmentId] = useChatEnvironmentAtom();
    const [environments, setEnvironments] = useState([]);  
  
    //const tabsWithDropdown = tabConfig.tabs.filter(tab => tab.dropdownItems.length > 0);
    //const shouldRenderTabs = tabConfig.tabs.length > 1 || tabsWithDropdown.length > 0;
    const clickedTab = tabConfig.tabs.find(tab => tab.intent === selectedTab);

    const handleTabItemChange = (event) => {
        const selectedValue = event.target.value;
        setTitCookie("TIT", event.target.value);
        setTabItemId(selectedValue);
    }

    const handleSelectEnvironment = (event) => {
      const selectedValue = event.target.value;
      setEnvCookie("ENV", event.target.value);
      setChatEnvironmentId(selectedValue);
    };
    
    useEffect(()=> {
      if (selectedTab === 'PromtEmbeddings') {
        getEnvironmentsforUser().then((data) => {
            setEnvironments(data);

            if (data.length > 0 && !chatEnvironmentId) {
              setChatEnvironmentId(data[0].Id);
            } 
        });
      }

      if (clickedTab?.dropdownItems?.length > 0) {
          const firstItemId = clickedTab.dropdownItems[0].id;
          setTabItemId(firstItemId);
      }
    },[selectedTab]);

    useEffect(()=> {
      console.log(selectedTab)
    },[selectedTab])

    return (
      <div className='tab-menu-bar'>
      {tabConfig.tabs && (
        <div className="tabs-wrapper">
          <div className="tabs">
            {tabConfig.tabs.map(tab => (
              <React.Fragment key={tab.radio}>

                <input
                  type="radio"
                  id={tab.radio}
                  name="tabs"
                  checked={selectedTab === tab.intent}
                  onChange={() => handleTabClick(tab.intent)}
                />

                <label className="tab" htmlFor={tab.radio}>
                  <span className="material-symbols-outlined mobileOnly">{tab.icon}</span>
                  <span className='pcOnly'>{t(tab.label)}</span>
                  
                  {selectedTab === tab.intent && (
                    tab.intent === 'PromtEmbeddings' ? (
                      <div className='dropdown-container'>
                        <select 
                          value={chatEnvironmentId} 
                          onChange={handleSelectEnvironment} 
                          className='tab-dropdown'
                        >
                          {environments.map((env, index) => (
                            <option key={index} value={env.Id}>
                              {env.Name}
                            </option>
                          ))}
                    </select>
                  </div>
                 ) : (
                  tab.dropdownItems?.length > 0 && (
                      <div className="dropdown-container">
                        <select
                          value={tabItemId || '' }
                          onChange={handleTabItemChange}
                          className="tab-dropdown" 
                        >
                          {tab.dropdownItems.map(item => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      )
                    )
                  )}
                </label>
              </React.Fragment>
            ))}
            <span className="glider"/>
          </div>
        </div>
      )}
    </div>
  )
};

export default Tabs;